var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"x-markdown"},[_c('v-row',{staticClass:"caption ml-3 mt-n3 mb-0"},[_vm._v(_vm._s(_vm.myTitle))]),_c('markdown-viewer',{staticClass:"mx-3",attrs:{"source":_vm.content,"height":_vm.myMultiline}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }